export default __webpack_public_path__ + "static/media/wristwraps_of_fiendish_invocation.34df07a4.jpg";